"use client";

import { createContext, useContext, type ReactNode } from "react";
import { useUser } from "@clerk/nextjs";
import { useEffectivePass } from "@/hooks/useEffectivePass";
import { useQuizSession } from "./useQuizSession";

import { useQuizTemplates, type QuizTemplatesState } from "./useQuizTemplates";

const QuizSessionContext = createContext<(ReturnType<typeof useQuizSession> & { templates: QuizTemplatesState }) | null>(null);

// 레이아웃 교체보다 위에 위치해 viewport 변경 시 세션을 유지한다.
export function QuizSessionBoundary({ children }: { children: ReactNode }) {
  const { user } = useUser();
  const { isLoaded, isSignedIn, isPremiumOrAbove } = useEffectivePass();
  if (!isLoaded || !isSignedIn || !isPremiumOrAbove || !user?.id) return children;
  return <QuizSessionProvider key={user.id} userId={user.id}>{children}</QuizSessionProvider>;
}

export function QuizSessionProvider({ userId, children }: { userId: string; children: ReactNode }) {
  const session = useQuizSession(userId);
  const templates = useQuizTemplates(session.setDraft);
  return <QuizSessionContext.Provider value={{ ...session, templates }}>{children}</QuizSessionContext.Provider>;
}

export function usePersonalQuizSession() {
  const session = useContext(QuizSessionContext);
  if (!session) throw new Error("나만의 시험지 세션 공급자가 필요합니다.");
  return session;
}
